// categories.js

import { baseURL } from 'utils/api'
import Dictionary from '../dictionary'
import axios from 'axios'

const { categories } = Dictionary

const categoriesServies = {
    view: async (paramsObj) => {
        return axios.get(baseURL + categories.list(), { params: paramsObj })
    },
    add: async (data) => {
        return axios.post(baseURL + categories.create(), data)
    },
    delete: async (id) => {
        return axios.delete(baseURL + categories.delete(id))
    },
    edit: async (id, data) => {
        return axios.put(baseURL + categories.update(id), data)
    },
    getDetailById: async (id) => {
        return axios.get(baseURL + categories.getById(id))
    },
    getSubCategoryById: async (id,paramsObj) => {
        return axios.get(baseURL + categories.subCategorylist(id), { params: paramsObj })
    },
}
export default categoriesServies